<div>
  <mat-form-field class="full-width">
  <input matInput placeholder="{{ this.placeHolder | translate}}" [ngClass]="{ 'one': editMode}" value="{{this.itemName}}" [disabled]="true">
    <i matSuffix class="glyphicon glyphicon-new-window link" (click)="showDropDownSelectorModal()" *ngIf="editMode"></i>
</mat-form-field>
</div>